/** Load GTM with Consent Mode defaults; Pandectes owns consent updates. */
(function (win, doc) {
  'use strict';

  const id = doc.currentScript?.dataset.gtmId;
  if (!/^GTM-[A-Z0-9]+$/.test(id || '')) return;

  if (win.__kieuGtmBootstrap === id) return;
  win.__kieuGtmBootstrap = id;

  let loaded = false;
  let featureRequested = false;

  function clearDeniedCookies() {
    try {
      const consent = win.Shopify?.customerPrivacy?.currentVisitorConsent?.();
      const analyticsDenied = consent?.analytics === 'no';
      const marketingDenied = consent?.marketing === 'no';
      if (!analyticsDenied && !marketingDenied) return;

      const names = new Set(String(doc.cookie || '').split(';').map((part) => part.split('=')[0].trim()));
      const hostname = String(win.location?.hostname || '').toLowerCase();
      const domains = new Set([null]);
      if (/^(?:[a-z0-9-]+\.)*[a-z0-9-]+$/.test(hostname)) {
        domains.add(hostname);
        domains.add(`.${hostname}`);
        if (hostname === 'drkieu.de' || hostname.endsWith('.drkieu.de')) {
          domains.add('drkieu.de');
          domains.add('.drkieu.de');
        }
      }

      for (const name of names) {
        const isAnalytics = name === '_ga' || /^_ga_[a-z0-9]+$/i.test(name);
        const isMarketing = name === '_gcl_au' || name === '_fbp';
        if (!(analyticsDenied && isAnalytics) && !(marketingDenied && isMarketing)) continue;
        for (const domain of domains) {
          doc.cookie = `${name}=; Max-Age=0; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/${domain ? `; Domain=${domain}` : ''}`;
        }
      }
    } catch (_) {
      // An unavailable cookie API must not affect booking or consent controls.
    }
  }

  function ensureConsentDefault() {
    const layer = win.dataLayer = win.dataLayer || [];
    const signals = ['ad_storage', 'analytics_storage', 'ad_user_data', 'ad_personalization'];
    const valid = (value) => value === 'granted' || value === 'denied';
    const hasDefault = layer.some((entry) => entry && entry[0] === 'consent' &&
      entry[1] === 'default' && entry[2] && !entry[2].region &&
      signals.every((signal) => valid(entry[2][signal])));
    if (hasDefault) return;
    // Retain any already queued partial or full updates if the CMP omitted its default.
    const current = {};
    for (const entry of layer) {
      if (entry && entry[0] === 'consent' && entry[1] === 'update' && entry[2]) {
        for (const signal of signals) if (valid(entry[2][signal])) current[signal] = entry[2][signal];
      }
    }
    function command() { layer.push(arguments); }
    command('consent', 'default', {
      ad_storage: 'denied', analytics_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied', wait_for_update: 500,
    });
    if (Object.keys(current).length) command('consent', 'update', current);
  }

  function loadContainer() {
    if (loaded) return;
    ensureConsentDefault();
    loaded = true;
    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

    const script = doc.createElement('script');
    script.async = true;
    script.referrerPolicy = 'no-referrer';
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
    (doc.head || doc.documentElement).appendChild(script);
  }

  function checkConsent() {
    clearDeniedCookies();
    loadContainer();
    const privacy = win.Shopify?.customerPrivacy;
    const apiReady = typeof privacy?.currentVisitorConsent === 'function'
      && typeof privacy?.analyticsProcessingAllowed === 'function'
      && typeof privacy?.marketingAllowed === 'function';
    if (apiReady || featureRequested ||
        typeof win.Shopify?.loadFeatures !== 'function') return;

    featureRequested = true;
    try {
      win.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) checkConsent();
      });
    } catch (_) {
      featureRequested = false;
    }
  }

  doc.addEventListener('visitorConsentCollected', checkConsent);
  doc.addEventListener('DOMContentLoaded', checkConsent, { once: true });
  win.addEventListener('pageshow', checkConsent);
  checkConsent();
})(window, document);
